<template>
  <lego-modal-extend-v2
    ref="modal"
    :width="540"
    height="auto"
    :title="title"
    @beforeClose="removeResult"
    customClass="authorization-modal-wrapper"
  >
    <c-scroll style="max-height: 400px">
      <div class="notice-content">
        <template v-if="isAccessDenied(authorizationCheckResult.type)">
          <div>
            {{ $t('errorCode.authorizationCheck.deny', [userEmail]) }}
          </div>
          <div>{{ $t('errorCode.authorizationCheck.contact') }}</div>

          <p style="color: #2f3237; font-size: 14px; font-weight: 500">
            {{ $t('errorCode.authorizationCheck.required_list') }}
          </p>

          <div class="wrap">
            <div class="style-item">
              <div class="title">[Service]:</div>
              <div class="value">{{ $util.capitalize(authorizationCheckResult.serviceName) }}</div>
            </div>

            <div class="style-item">
              <div class="title">[Action]:</div>
              <div class="value">
                {{ actionName }}
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="isResourceNotFound">
          <div style="margin-bottom: 10px" v-html="getResourceNotFoundErrorMessage"></div>
        </template>

        <div
          v-if="authorizationCheckResult.resourceNames.length"
          :class="{ wrap: isResourceNotFound, wrap_padding: !isResourceNotFound }"
        >
          <div class="style-item">
            <div class="title">[{{ resourceName }}]:</div>
            <div class="value">{{ resourceIds }}</div>
          </div>
        </div>
      </div>
    </c-scroll>

    <template #footer>
      <lego-button main @click="closeModal">{{ t('button.confirm') }}</lego-button>
    </template>
  </lego-modal-extend-v2>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import LegoModalExtendV2 from '@/components/lego/extend/legoModalExtendV2.vue';
import { AuthorizationResult } from '@/store/modules/auth';

export default {
  name: 'AuthorizationCheckResultModal',
  components: { LegoModalExtendV2 },
  mixins: [i18nMixin],
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  computed: {
    isResourceNotFound() {
      return this.result.type === AuthorizationResult.RESOURCE_NOT_FOUND;
    },
    getResourceNotFoundErrorMessage() {
      const customMessage = this.result.errorMessages.find((err) => err.type === this.result.type);

      return customMessage
        ? customMessage.message
        : this.$t('errorCode.authorizationCheck.resource_not_found');
    },
    title() {
      if (this.isAccessDenied(this.result.type))
        return this.$t('errorCode.authorizationCheck.deny_title');

      return this.$t('errorCode.authorizationCheck.title');
    },
    resourceName() {
      if (this.isAccessDenied(this.result.type)) {
        return 'Resource';
      }
      return this.$t('errorCode.authorizationCheck.resource');
    },
    userEmail() {
      return (
        (this.$http.getRoleId()
          ? window.sessionStorage.getItem('roleName') +
            '@' +
            window.sessionStorage.getItem('projectId')
          : window.sessionStorage.getItem('userEmail')) || 'gilding.hong@samsung.com'
      );
    },
    actionName() {
      if (Array.isArray(this.authorizationCheckResult.actionName))
        return this.authorizationCheckResult.actionName
          .map((action) => this.$util.capitalize(action))
          .join(', ');
      return this.$util.capitalize(this.authorizationCheckResult.actionName);
    },
    resourceIds() {
      const uniqueResourceIds = new Set(this.authorizationCheckResult.resourceIds);
      return Array.from(uniqueResourceIds).join(', ');
    }
  },
  data() {
    return {
      AuthorizationResult,
      denyErrors: [AuthorizationResult.DENY, AuthorizationResult.ACCESS_DENIED],
      authorizationCheckResult: this.result
    };
  },
  mounted() {
    this.$refs['modal'].open();
  },
  methods: {
    closeModal() {
      this.$refs['modal'].close();
    },
    removeResult(closeBaseModal) {
      this.$store.dispatch('authStore/removeResult', this.authorizationCheckResult.id);
      closeBaseModal();
    },
    isAccessDenied(type) {
      return this.denyErrors.includes(type);
    }
  }
};
</script>
<style lang="scss" scoped>
.notice-content {
  padding: 20px 20px 15px 0;
  word-break: break-word;

  .wrap {
    padding: 12px;
    background: #f7f7f8;
  }

  .wrap_padding {
    padding: 0 12px 12px 12px !important;
    background: #f7f7f8;
  }

  .style-item {
    display: flex;
    gap: 8px;

    .title {
      width: 80px;
    }

    .value {
      flex: 1;
    }
  }

  .style-item + .style-item {
    margin-top: 10px;
  }
}

.authorization-modal-wrapper {
  z-index: 9000 !important;
}
</style>
